import React from "react";
import { X, Star, Plus, Leaf } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const QuickView = ({ product, onClose, onAdd }) => {
  return (
    <AnimatePresence>
      {product && (
        <div
          data-testid="quick-view-modal"
          className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8 font-outfit"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="relative bg-[#F7F5F0] w-full max-w-4xl max-h-[88vh] overflow-y-auto grid grid-cols-1 md:grid-cols-2 shadow-2xl"
          >
            <button
              data-testid="quick-view-close-button"
              onClick={onClose}
              className="absolute top-4 right-4 z-10 p-2 bg-[#F7F5F0]/80 hover:bg-[#E2DACF] transition-colors rounded-full"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="bg-[#E2DACF] overflow-hidden">
              <img
                src={product.detailImage || product.image}
                alt={product.title}
                className="w-full h-64 md:h-full object-cover"
              />
            </div>

            <div className="p-8 sm:p-10 space-y-5 flex flex-col">
              <div>
                <p className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#C47D65]">
                  {product.category}
                </p>
                <h2 className="font-cormorant text-3xl sm:text-4xl font-light leading-tight mt-2">
                  {product.title}
                </h2>
              </div>

              <div className="flex items-center gap-3">
                <span className="text-2xl font-medium tracking-tight">
                  ₹{product.price.toLocaleString("en-IN")}
                </span>
                <span className="flex items-center gap-1 text-sm text-[#5C6B5F]">
                  <Star className="w-4 h-4 fill-[#C47D65] text-[#C47D65]" />
                  {product.rating} · {product.reviewsCount} reviews
                </span>
              </div>

              <p className="text-sm text-[#5C6B5F] font-light leading-relaxed">
                {product.description}
              </p>

              <div className="flex flex-wrap gap-2">
                {product.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[10px] tracking-[0.12em] uppercase font-semibold border border-[#C47D65]/40 text-[#5C6B5F] px-3 py-1"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <div className="bg-white border border-[#E2DACF] p-4 text-xs text-[#5C6B5F] leading-relaxed flex gap-3">
                <Leaf className="w-4 h-4 text-[#C47D65] shrink-0 mt-0.5" />
                {product.details}
              </div>

              <button
                data-testid="quick-view-add-button"
                onClick={() => {
                  onAdd(product);
                  onClose();
                }}
                className="mt-auto w-full bg-[#2B3A2F] text-[#F7F5F0] py-4 hover:bg-[#1E2922] transition-all text-xs tracking-[0.2em] uppercase font-medium flex items-center justify-center gap-2"
              >
                <Plus className="w-4 h-4" /> Add to Basket
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
